import * as Oidc from 'oidc-client';

export const PortaInit = async () => {
  // Set the OpenID Connect authority URL
  const oidcAuthorityUrl = 'https://login.cncenter.cz/';

  // Get the current webpage URLl
  const currentPageUrl = window.location.href;

  // Define client IDs for authentication based on webpage URL
  let clientId: string;
  // Set the redirect URI after successful authentication
  let redirectUri: string;
  if (currentPageUrl.includes('e15.cz')) {
    clientId = 'c53cb907-52df-416a-9b7b-f8bb5cee38a3'; //Tento klic dostavame od porty a je primo jenom pro e15
    redirectUri = `https://www.e15.cz/prihlaseni/login/porta?redirect_uri=${encodeURIComponent(currentPageUrl)}`;
  } else if (currentPageUrl.includes('reflex.cz')) {
    clientId = 'c9358501-8e9d-4b06-bdcd-b12ff422f4ca'; //Tento klic dostavame od porty a je primo jenom pro reflex
    redirectUri = `https://www.reflex.cz/prihlaseni/login/porta?redirect_uri=${encodeURIComponent(currentPageUrl)}`;
  } else if (currentPageUrl.includes('zeny.cz')) {
    clientId = '31a27051-ed2e-4f0b-b67b-44e60fc18b69'; //Tento klic dostavame od porty a je primo jenom pro zeny
    redirectUri = `https://www.zeny.cz/prihlaseni/login/porta?redirect_uri=${encodeURIComponent(currentPageUrl)}`;
  } else if (currentPageUrl.includes('lideazeme.cz')) {
    clientId = 'a838c5b8-2bdc-4c06-9bab-3af2424694ba'; //Tento klic dostavame od porty a je primo jenom pro lideazeme
    redirectUri = `https://www.lideazeme.cz/prihlaseni/login/porta?redirect_uri=${encodeURIComponent(currentPageUrl)}`;
  } else if (currentPageUrl.includes('auto.cz')) {
    clientId = '182563bd-b658-4f58-8282-f0485f3a5aaa'; //Tento klic dostavame od porty a je primo jenom pro auto.cz
    redirectUri = `https://www.auto.cz/prihlaseni/login/porta?redirect_uri=${encodeURIComponent(currentPageUrl)}`;
  } else if (currentPageUrl.includes('mojepsychologie.cz')) {
    clientId = 'b8c013e0-9a08-48ef-81de-fd6a44932841'; //Tento klic dostavame od porty a je primo jenom pro mojepsychologie.cz
    redirectUri = `https://www.mojepsychologie.cz/prihlaseni/login/porta?redirect_uri=${encodeURIComponent(currentPageUrl)}`;
  } else {
    // Default client ID or handle other cases as needed
    clientId = '#';
    redirectUri = '#';
  }

  // Define client ID for authentication
  const dataclientId = '724554886791-45p9r05mklnbvama9srjsu614uis17vg.apps.googleusercontent.com'; //Master key from Google Develop console

  // Specify the response type for authentication
  const responseType = 'code';

  // Define the scope of requested user information and access
  const scope = 'cnc.myaccount offline_access openid email profile';

  // Create a new instance of the Oidc.UserManager with provided settings
  const userManager = new Oidc.UserManager({
    authority: oidcAuthorityUrl,
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: responseType,
    scope: scope,
  });

  let generatedUrl;

  // Create a signin request using the userManager
  const signinRequest = await userManager.createSigninRequest();

  // Check if url exists in response
  if (signinRequest?.url) {
    // Parse the URL of the signin request
    const url = new URL(signinRequest?.url);
    // Get the params of the parsed url
    const params = new URLSearchParams(url.search.substring(1));

    generatedUrl =
      oidcAuthorityUrl +
      'ExternalLogin/ExternalLogin?provider=Google&returnUrl=' +
      encodeURIComponent(
        '/connect/authorize/callback?client_id=' +
          clientId +
          '&redirect_uri=' +
          redirectUri +
          '&response_type=' +
          responseType +
          '&scope=' +
          scope +
          '&state=' +
          params.get('state') +
          '&code_challenge=' +
          params.get('code_challenge') +
          '&code_challenge_method=' +
          params.get('code_challenge_method') +
          '&response_mode=' +
          params.get('response_mode')
      );
  }

  // Creating a div element for Google Sign-In configuratio
  const googleDiv: HTMLDivElement = document.createElement('div');
  googleDiv.id = 'g_id_onload';
  googleDiv.setAttribute('data-client_id', dataclientId);
  googleDiv.setAttribute('data-login_uri', generatedUrl || '');
  googleDiv.setAttribute('data-cancel_on_tap_outside', 'false');

  document.body.appendChild(googleDiv);

  // Create a script element for Google Sign-In
  const googleScript: HTMLScriptElement = document.createElement('script');
  googleScript.src = 'https://accounts.google.com/gsi/client';
  googleScript.async = true;
  googleScript.defer = true;

  // Append the script element to the document's head
  document.body.appendChild(googleScript);
};
